export const FETCH_REFERENCE_DATA_REQUEST = "FETCH_REFERENCE_DATA_REQUEST";
export const FETCH_REFERENCE_DATA_SUCCESS = "FETCH_REFERENCE_DATA_SUCCESS";
export const FETCH_REFERENCE_DATA_FAILURE = "FETCH_REFERENCE_DATA_FAILURE";

export function fetchAllReferenceData(payload) {
  return {
    type: FETCH_REFERENCE_DATA_REQUEST,
    payload,
  };
}

export function fetchAllReferenceDataSuccess(payload) {
  return {
    type: FETCH_REFERENCE_DATA_SUCCESS,
    payload,
  };
}

export function fetchAllReferenceDataFail(payload) {
  return {
    type: FETCH_REFERENCE_DATA_FAILURE,
    payload,
  };
}
